import type { CampaignBase } from '@/entities/campaign';
import { DATE_FORMATS } from '@/shared/utils/date/date-formats';
import dayjs from 'dayjs';

export function formatCampaignPeriod(
  startDate: CampaignBase['start_date'],
  endDate?: CampaignBase['end_date'],
) {
  const startLabel = dayjs(startDate).format(DATE_FORMATS.base);
  if (!endDate) return `${startLabel} - Open ended`;
  return `${startLabel} - ${dayjs(endDate).format(DATE_FORMATS.base)}`;
}
